import { ENOTIFICATION_SUBMIT } from "../../actionTypes/actionsTypes";
import { AppAction, BaseAsyncReducerState } from "../../types"


const initialState: BaseAsyncReducerState = {
    loading: false,
    error: false,
    success: false,
    status: 0
}

export function enotifUpdateReducer(state = initialState, action: AppAction) {
        const { payload } = action;

    switch (action.type) {
        case ENOTIFICATION_SUBMIT.PENDING:
            return {
                ...state,
                loading: true,
                error: false,
            }
        case ENOTIFICATION_SUBMIT.SUCCESS:
            return {
                ...state,
                ...payload,
                loading: false,
                error: false,
            }
        case ENOTIFICATION_SUBMIT.ERROR:
            return {
                ...state,
                loading: false,
                error: payload
            };
        case ENOTIFICATION_SUBMIT.RESET:
            return {
                ...state,
                ...initialState
            };

        default:
            // If the reducer doesn't care about this action type,
            // return the existing state unchanged
            return state
    }
}